import React, { useState } from 'react';
import Numeral from 'numeral';
import moment from 'moment';
import semver from 'semver';

export const getParseServerVersion = (parseServerVersion) => {
  let version;
  if (typeof parseServerVersion === 'string' && parseServerVersion.startsWith("release-")) {
    const tmp_version = parseServerVersion.replace('release-', '');
    if (semver.valid(tmp_version)) {
      version = tmp_version;
    }
  }

  return version;
}

export const jsonEqual = (a, b) => {
  return JSON.stringify(a) === JSON.stringify(b);
};

export const isEmptyObject = (obj) => {
  return (Object.getOwnPropertyNames(obj).length === 0);
};

export function bytesToSize(bytes) {
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  if (bytes === 0) return '0 Byte';
  const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
  return `${Math.round(bytes / Math.pow(1024, i), 2)} ${sizes[i]}`;
}

export function numeral(v, f, isHTML) {
  let value = Numeral(v).format(f);

  if (isHTML) {
    value = value.split(' ');
    return (
      <span className="formatted" dangerouslySetInnerHTML={{ __html: `${value[0]}<span>${value[1]}</span>` }} />
    );
  }

  return value;
}

export const addOrUpdate = (arr = [], comp, update) => {
  let updated = false;
  arr.map((e, i) => {
    if (e[comp] === update[comp]) {
      updated = true;
      arr[i] = update;
    }
  });

  if (!updated) {
    arr.unshift(update);
  }

  return arr;
};

export const sortObject = (o) => {
  return Object.keys(o).sort().reduce((r, k) => (r[k] = o[k], r), {});
};

export const nanoSecondsFormat = (nS) => {
  const nanoS = nS / 1000000;
  const min = moment(nanoS).format('m');
  const sec = moment(nanoS).format('s');

  return `${min > 0 ? `${min}m` : ''} ${sec}s`;
};

export function isPrivateMode() {
  return new Promise((resolve) => {
    const on = () => resolve(true); // is in private mode
    const off = () => resolve(false); // not private mode
    const testLocalStorage = () => {
      try {
        if (localStorage.length) off();
        else {
          localStorage.x = 1;
          localStorage.removeItem('x');
          off();
        }
      }
      catch (e) {
        // Safari only enables cookie in private mode
        // if cookie is disabled then all client side storage is disabled
        // if all client side storage is disabled, then there is no point
        // in using private mode
        navigator.cookieEnabled ? on() : off();
      }
    };
    // Chrome & Opera
    if (window.webkitRequestFileSystem) {
      return void window.webkitRequestFileSystem(0, 0, off, on);
    }
    // Firefox
    if ('MozAppearance' in document.documentElement.style) {
      const db = indexedDB.open('test');
      db.onerror = on;
      db.onsuccess = off;
      return void 0;
    }
    // Safari
    if (/constructor/i.test(window.HTMLElement)) {
      return testLocalStorage();
    }
    // IE10+ & Edge
    if (!window.indexedDB && (window.PointerEvent || window.MSPointerEvent)) {
      return on();
    }
    // others
    return off();
  });
}


export const getBase64ImageFromUrl = async (imageUrl) => {
  const res = await fetch(imageUrl);
  const blob = await res.blob();

  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.addEventListener('load', () => {
      resolve(reader.result);
    }, false);

    reader.onerror = () => {
      return reject(this);
    };
    reader.readAsDataURL(blob);
  });
};

export const useSetState = (initialState = {}) => {
  const [state, set] = useState(initialState);
  const setState = patch => {
    set(prev => Object.assign({}, prev, patch instanceof Function ? patch(prev) : patch));
  };

  return [state, setState];
};
